import { fetchJson } from 'utils/fetchJson/fetchJson';
import { API_URL_V3 } from '../../../constants';

const countries = {
  fetch: ({ locale = 'EN' } = {}) => {
    const path = `${API_URL_V3}/countries?locale=${locale}`;

    return fetchJson(path);
  },
};

export { countries };
